import { NodeWithMultipleHandles } from '../NodeWithMultipleHandles';

export const TestAgentNode = (props) => {
    return <NodeWithMultipleHandles {...props} nodeType="testagent" />;
};
